"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_LOYALTY_NUM = exports.UPDATE_CONNECTION_PENDING = exports.UNENROLL_MODAL = exports.UNENROLL_LISTING = exports.TOGGLE_NEED_AN_ACCOUNT_CLICKED = exports.TOGGLE_MODAL = exports.SET_IS_CONNECTING_TO_FALSE = exports.SET_ERRORS = exports.REGIONS_FETCH_FAILED = exports.REGIONS_FETCHED = exports.LISTING_SHOULD_FETCH = exports.LISTING_NOT_FOUND = exports.LISTING_FETCH_FAILED = exports.LISTING_FETCHING = exports.LISTING_FETCHED = exports.INQUIRE_LISTING = exports.ENROLL_MODAL = exports.DISCONNECT_MODAL = exports.DISCONNECT_LISTING = exports.COUNTRIES_FETCH_FAILED = exports.COUNTRIES_FETCHED = exports.CONNECT_LISTING = exports.CONNECTION_STATUS_CHECKING = exports.CONNECTION_STATUS_CHECKED_SUCCESS = exports.CONFIRMATION_MODAL = void 0;
exports.checkForConnection = checkForConnection;
exports.clearError = clearError;
exports.connectListing = connectListing;
exports.default = listing;
exports.disconnectFromListing = void 0;
exports.disconnectListing = disconnectListing;
exports.fetchListItems = void 0;
exports.fetchListing = fetchListing;
exports.fetchListingIfNeeded = fetchListingIfNeeded;
exports.fetchLocalizedCountries = fetchLocalizedCountries;
exports.fetchLocalizedRegions = fetchLocalizedRegions;
exports.initialState = void 0;
exports.inquireListing = inquireListing;
exports.queryBuilder = queryBuilder;
exports.shouldFetchListing = shouldFetchListing;
exports.toggleModal = void 0;
exports.toggleNeedAnAccountClicked = toggleNeedAnAccountClicked;
exports.updateLoyaltyNum = updateLoyaltyNum;
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _merge11 = _interopRequireDefault(require("lodash/merge"));
var _reduce2 = _interopRequireDefault(require("lodash/reduce"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _utils = require("../utils");
var _listingsModule = require("../listings/listingsModule");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _require = require('uuid'),
  uuid = _require.v4;

// Constants

var SET_ERRORS = exports.SET_ERRORS = '@@listingModule/SET_ERRORS';
var LISTING_FETCHING = exports.LISTING_FETCHING = '@@listingModule/LISTING_FETCHING';
var LISTING_FETCHED = exports.LISTING_FETCHED = '@@listingModule/LISTING_FETCHED';
var LISTING_NOT_FOUND = exports.LISTING_NOT_FOUND = '@@listingModule/LISTING_NOT_FOUND';
var LISTING_FETCH_FAILED = exports.LISTING_FETCH_FAILED = '@@listingModule/LISTING_FETCH_FAILED';
var LISTING_SHOULD_FETCH = exports.LISTING_SHOULD_FETCH = '@@listingModule/LISTING_SHOULD_FETCH';
var CONNECT_LISTING = exports.CONNECT_LISTING = '@@listingModule/CONNECT_LISTING';
var UNENROLL_LISTING = exports.UNENROLL_LISTING = '@@listingModule/UNENROLL_LISTING';
var DISCONNECT_LISTING = exports.DISCONNECT_LISTING = '@@listingModule/DISCONNECT_LISTING';
var INQUIRE_LISTING = exports.INQUIRE_LISTING = '@@listingModule/INQUIRE_LISTING';
var REGIONS_FETCHED = exports.REGIONS_FETCHED = '@@listingModule/REGIONS_FETCHED';
var COUNTRIES_FETCHED = exports.COUNTRIES_FETCHED = '@@listingModule/COUNTRIES_FETCHED';
var REGIONS_FETCH_FAILED = exports.REGIONS_FETCH_FAILED = '@@listingModule/REGIONS_FETCH_FAILED';
var COUNTRIES_FETCH_FAILED = exports.COUNTRIES_FETCH_FAILED = '@@listingModule/COUNTRIES_FETCH_FAILED';
var UPDATE_LOYALTY_NUM = exports.UPDATE_LOYALTY_NUM = '@@listingModule/UPDATE_LOYALTY_NUM';
var TOGGLE_MODAL = exports.TOGGLE_MODAL = '@@listingModule/TOGGLE_MODAL';
var CONNECTION_STATUS_CHECKING = exports.CONNECTION_STATUS_CHECKING = '@@listingModule/CONNECTION_STATUS_CHECKING';
var CONNECTION_STATUS_CHECKED_SUCCESS = exports.CONNECTION_STATUS_CHECKED_SUCCESS = '@@listingModule/CONNECTION_STATUS_CHECKED_SUCCESS';
var SET_IS_CONNECTING_TO_FALSE = exports.SET_IS_CONNECTING_TO_FALSE = '@@listingModule/SET_IS_CONNECTING_TO_FALSE';
var UPDATE_CONNECTION_PENDING = exports.UPDATE_CONNECTION_PENDING = '@@listingModule/UPDATE_CONNECTION_PENDING';
var TOGGLE_NEED_AN_ACCOUNT_CLICKED = exports.TOGGLE_NEED_AN_ACCOUNT_CLICKED = '@@listingModule/TOGGLE_NEED_AN_ACCOUNT_CLICKED';

// Modal Names

var ENROLL_MODAL = exports.ENROLL_MODAL = '@@listingModule/ENROLL_MODAL';
var UNENROLL_MODAL = exports.UNENROLL_MODAL = '@@listingModule/UNENROLL_MODAL';
var DISCONNECT_MODAL = exports.DISCONNECT_MODAL = '@@listingModule/DISCONNECT_MODAL';
var CONFIRMATION_MODAL = exports.CONFIRMATION_MODAL = '@@listingModule/CONFIRMATION_MODAL';

// Helper

var fetchListItems = exports.fetchListItems = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang, item) {
    var endpoint, options, response, json;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          endpoint = "".concat((0, _utils.getAPIEndpoint)(), "/listitems/").concat(item, "?lang=").concat(lang);
          options = {
            method: 'GET',
            headers: {}
          };
          _context.next = 4;
          return (0, _isomorphicFetch.default)(endpoint, options);
        case 4:
          response = _context.sent;
          _context.next = 7;
          return response.json();
        case 7:
          json = _context.sent;
          return _context.abrupt("return", json);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchListItems(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// Actions

var disconnectFromListing = exports.disconnectFromListing = function disconnectFromListing(listingId) {
  return {
    type: DISCONNECT_LISTING,
    listingId: listingId
  };
};
function fetchLocalizedRegions() {
  return /*#__PURE__*/function () {
    var _fetchLocalizedRegionsAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var _getState, _getState$userPrefs, _getState$userPrefs2, _getState$userPrefs2$, _getState$userPrefs2$2, _getState$userPrefs2$3, lang, _getState$listing, _getState$listing2, localizedRegions, json;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _getState = getState(), _getState$userPrefs = _getState.userPrefs, _getState$userPrefs2 = _getState$userPrefs === void 0 ? {} : _getState$userPrefs, _getState$userPrefs2$ = _getState$userPrefs2.localeData, _getState$userPrefs2$2 = _getState$userPrefs2$ === void 0 ? {} : _getState$userPrefs2$, _getState$userPrefs2$3 = _getState$userPrefs2$2.lang, lang = _getState$userPrefs2$3 === void 0 ? 'en-us' : _getState$userPrefs2$3, _getState$listing = _getState.listing, _getState$listing2 = _getState$listing === void 0 ? {} : _getState$listing, localizedRegions = _getState$listing2.localizedRegions;
            if (!localizedRegions) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return fetchListItems(lang, 'regions');
          case 6:
            json = _context2.sent;
            dispatch({
              type: REGIONS_FETCHED,
              json: json
            });
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
            dispatch({
              type: REGIONS_FETCH_FAILED
            });
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 10]]);
    }));
    function fetchLocalizedRegionsAsync(_x3, _x4) {
      return _fetchLocalizedRegionsAsync.apply(this, arguments);
    }
    return fetchLocalizedRegionsAsync;
  }();
}
function fetchLocalizedCountries() {
  return /*#__PURE__*/function () {
    var _fetchLocalizedCountriesAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var _getState2, _getState2$userPrefs, _getState2$userPrefs2, _getState2$userPrefs3, _getState2$userPrefs4, _getState2$userPrefs5, lang, _getState2$listing, _getState2$listing2, localizedCountries, json;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _getState2 = getState(), _getState2$userPrefs = _getState2.userPrefs, _getState2$userPrefs2 = _getState2$userPrefs === void 0 ? {} : _getState2$userPrefs, _getState2$userPrefs3 = _getState2$userPrefs2.localeData, _getState2$userPrefs4 = _getState2$userPrefs3 === void 0 ? {} : _getState2$userPrefs3, _getState2$userPrefs5 = _getState2$userPrefs4.lang, lang = _getState2$userPrefs5 === void 0 ? 'en-us' : _getState2$userPrefs5, _getState2$listing = _getState2.listing, _getState2$listing2 = _getState2$listing === void 0 ? {} : _getState2$listing, localizedCountries = _getState2$listing2.localizedCountries;
            if (!localizedCountries) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            _context3.prev = 3;
            _context3.next = 6;
            return fetchListItems(lang, 'countries');
          case 6:
            json = _context3.sent;
            dispatch({
              type: COUNTRIES_FETCHED,
              json: json
            });
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](3);
            dispatch({
              type: COUNTRIES_FETCH_FAILED
            });
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 10]]);
    }));
    function fetchLocalizedCountriesAsync(_x5, _x6) {
      return _fetchLocalizedCountriesAsync.apply(this, arguments);
    }
    return fetchLocalizedCountriesAsync;
  }();
}
function fetchListing(listingId) {
  return /*#__PURE__*/function () {
    var _fetchListingAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var _getState3, _getState3$userProfil, _getState3$userProfil2, profile, _getState3$userPrefs, _getState3$userPrefs2, _getState3$userPrefs3, _getState3$userPrefs4, _getState3$userPrefs5, lang, endpoint, options, response, result, action;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(listingId === undefined)) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return", Promise.reject('missing listingId from function argument'));
          case 2:
            _getState3 = getState(), _getState3$userProfil = _getState3.userProfile, _getState3$userProfil2 = _getState3$userProfil === void 0 ? {} : _getState3$userProfil, profile = _getState3$userProfil2.profile, _getState3$userPrefs = _getState3.userPrefs, _getState3$userPrefs2 = _getState3$userPrefs === void 0 ? {} : _getState3$userPrefs, _getState3$userPrefs3 = _getState3$userPrefs2.localeData, _getState3$userPrefs4 = _getState3$userPrefs3 === void 0 ? {} : _getState3$userPrefs3, _getState3$userPrefs5 = _getState3$userPrefs4.lang, lang = _getState3$userPrefs5 === void 0 ? 'en-us' : _getState3$userPrefs5;
            endpoint = "".concat((0, _utils.getAPIEndpoint)(profile), "/listings/").concat(listingId, "?lang=").concat(lang, "&returnalways=true");
            dispatch({
              type: LISTING_FETCHING,
              listingId: listingId
            });
            options = {
              method: 'GET',
              headers: {}
            };
            options.credentials = 'include';
            _context4.prev = 7;
            _context4.next = 10;
            return (0, _isomorphicFetch.default)(endpoint, options);
          case 10:
            response = _context4.sent;
            _context4.next = 13;
            return response.json();
          case 13:
            result = _context4.sent;
            action = response.status !== 404 ? {
              type: LISTING_FETCHED,
              listingId: listingId,
              result: result
            } : {
              type: LISTING_NOT_FOUND,
              listingId: listingId,
              result: result.message
            };
            dispatch(action);
            _context4.next = 21;
            break;
          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](7);
            return _context4.abrupt("return", dispatch({
              type: LISTING_FETCH_FAILED,
              listingId: listingId,
              error: _context4.t0
            }));
          case 21:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[7, 18]]);
    }));
    function fetchListingAsync(_x7, _x8) {
      return _fetchListingAsync.apply(this, arguments);
    }
    return fetchListingAsync;
  }();
}
function shouldFetchListing(state, listingId) {
  if (!state.listing) {
    throw new Error('Invalid State. Must have `.listing` field');
  }
  var listingInState = state.listing[listingId];
  var listingData = (0, _get2.default)(listingInState, 'data', false);
  if (!listingData || listingInState.readyState === LISTING_FETCH_FAILED) {
    return true;
  }
  return false;
}
function clearError(listingId, errorId) {
  return function (dispatch, getState) {
    var errors = getState().listing.errors[listingId] || [];
    var errorsPrime = errors.filter(function (error) {
      return error.componentId !== errorId;
    });
    dispatch(setErrors(listingId, errorsPrime));
  };
}

// fire and forget. return value doesn't matter and is a no-op if not needed
function fetchListingIfNeeded(listingId) {
  return function (dispatch, getState) {
    if (!listingId) {
      return Promise.reject('missing listingId from function argument');
    }
    if (shouldFetchListing(getState(), listingId)) {
      dispatch({
        type: LISTING_SHOULD_FETCH,
        value: true
      });
      return dispatch(fetchListing(listingId));
    }
    dispatch({
      type: LISTING_SHOULD_FETCH,
      value: false
    });
    // keep a consistent interface (promise)
    return Promise.resolve();
  };
}
function queryBuilder(options) {
  var parameterDefinitions = {
    clientId: 'client_id',
    connectURL: 'redirect_uri'
  };
  var keysArr = (0, _keys2.default)(options);
  var nonEmptyOptionsKeys = (0, _filter2.default)(keysArr, function (key) {
    return options[key] !== '' && options[key] !== undefined;
  });
  var querystring = (0, _reduce2.default)(nonEmptyOptionsKeys, function (memo, option) {
    var paramString;
    if (parameterDefinitions[option] !== undefined) {
      paramString = "".concat(parameterDefinitions[option], "=").concat(encodeURIComponent(options[option]));
    } else {
      paramString = "".concat(option, "=").concat(encodeURIComponent(options[option]));
    }
    return memo === '' ? "?".concat(paramString) : "".concat(memo, "&").concat(paramString);
  }, '');
  return querystring;
}
var makeXMLHttpRequest = function makeXMLHttpRequest(requestUrl, method) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    request.open(method || 'GET', requestUrl);
    request.onload = function () {
      if (request.status === 200) {
        resolve(true);
      } else {
        reject(false);
      }
    };
    request.send();
  });
};
function disconnectTripIt(csrfToken) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    request.open('POST', '/net2/TripIt/UnlinkFromTripIt.ashx');
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    request.onload = function () {
      if (request.status === 200) {
        resolve(true);
      } else {
        reject(false);
      }
    };
    request.send("csrf_token=".concat(csrfToken));
  });
}
var updateConnectionPending = function updateConnectionPending(listingId) {
  return {
    type: UPDATE_CONNECTION_PENDING,
    listingId: listingId
  };
};
function connectWithLoyaltyNumberLegacy(ID) {
  _nuiLogger.default.info({
    description: "AUTOCONFLOW connect request for listing ".concat(ID),
    category: 'autoconflow-connect-request'
  });
  return function (dispatch, getState) {
    var _getState$listing$ID$ = getState().listing[ID].data,
      loyaltyNumber = _getState$listing$ID$.loyaltyNumber,
      _getState$listing$ID$2 = _getState$listing$ID$.core,
      triplinkSupplierID = _getState$listing$ID$2.triplinkSupplierID,
      triplinkLoyaltyNumber = _getState$listing$ID$2.triplinkLoyaltyNumber;
    var addLoyaltyUrl = "/UI/appcenter/AddLoyaltyNumber?supplierId=".concat(triplinkSupplierID, "&loyaltyNumber=").concat(loyaltyNumber);
    var autoConnectUrl = "/UI/appcenter/AutoConnectToSupplier?supplierId=".concat(triplinkSupplierID);
    if (!triplinkLoyaltyNumber) {
      makeXMLHttpRequest(addLoyaltyUrl).then(function () {
        makeXMLHttpRequest(autoConnectUrl);
      }).then(function () {
        dispatch(updateConnectionPending(ID));
      });
    } else {
      makeXMLHttpRequest(autoConnectUrl).then(function () {
        dispatch(updateConnectionPending(ID));
      });
    }
  };
}
function toggleNeedAnAccountClicked(wasClicked) {
  return function (dispatch) {
    return dispatch({
      type: TOGGLE_NEED_AN_ACCOUNT_CLICKED,
      wasClicked: wasClicked
    });
  };
}
var connectionStatusChecking = function connectionStatusChecking() {
  return {
    type: CONNECTION_STATUS_CHECKING
  };
};
var setErrors = function setErrors(listingId, errors) {
  return {
    type: SET_ERRORS,
    errors: errors,
    listingId: listingId
  };
};
function checkForConnection(listingId, v1ListingId, popupWindow) {
  return function (dispatch, getState) {
    var _getState4 = getState();
    _objectDestructuringEmpty(_getState4.JWT);
    var _getState4$userProfil = _getState4.userProfile,
      _getState4$userProfil2 = _getState4$userProfil === void 0 ? {} : _getState4$userProfil,
      profile = _getState4$userProfil2.profile,
      _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang,
      lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;
    var ID = (0, _has2.default)(getState(), "listing[".concat(listingId, "].data.core")) ? listingId : v1ListingId;
    var currentConnectionState = getState().listing[ID].data.core.isUserConnected;
    dispatch(connectionStatusChecking());
    var popupClosedCounter = 0;
    var intervalID = window.setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var options, endpoint, response, json;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (popupWindow && popupWindow.closed && popupClosedCounter < 3) {
              popupClosedCounter += 1;
              if (popupClosedCounter === 2) {
                dispatch({
                  type: SET_IS_CONNECTING_TO_FALSE
                });
                dispatch(toggleNeedAnAccountClicked(false));
                window.clearInterval(intervalID);
              }
            }
            options = {
              method: 'GET',
              headers: {}
            };
            options.credentials = 'include';
            endpoint = "".concat((0, _utils.getAPIEndpoint)(profile), "/listings/").concat(ID, "?lang=").concat(lang, "&returnalways=true");
            _context5.prev = 4;
            _context5.next = 7;
            return (0, _isomorphicFetch.default)(endpoint, options);
          case 7:
            response = _context5.sent;
            _context5.next = 10;
            return response.json();
          case 10:
            json = _context5.sent;
            if (currentConnectionState !== json.core.isUserConnected) {
              dispatch({
                type: CONNECTION_STATUS_CHECKED_SUCCESS,
                ID: ID
              });
              dispatch(json.core.isUserConnected ? {
                type: CONNECT_LISTING
              } : disconnectFromListing(ID));
              dispatch((0, _listingsModule.updateConnectedStatus)(ID, json.core.isUserConnected));
              window.clearInterval(intervalID);
            }
            _context5.next = 17;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](4);
            dispatch({
              type: LISTING_FETCH_FAILED,
              ID: ID,
              error: _context5.t0
            });
          case 17:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[4, 14]]);
    })), 2000);
  };
}
var getListingID = function getListingID(listingId, v1ListingId, state) {
  var ID;
  if ((0, _has2.default)(state, "listing[".concat(listingId, "].data.core"))) {
    ID = listingId;
  } else {
    ID = v1ListingId;
  }
  return ID;
};
var openConnectionWindow = function openConnectionWindow(_ref3) {
  var url = _ref3.url,
    width = _ref3.width,
    height = _ref3.height,
    openerAllowed = _ref3.openerAllowed;
  // Centering popup within open parent window
  var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
  var windowTop = window.screenTop ? window.screenTop : window.screenY;
  var left = windowLeft + window.innerWidth / 2 - width / 2;
  var top = windowTop + window.innerHeight / 2 - height / 2;
  var windowFeatures = "scrollbars=1,resizable=1,width=".concat(width, ", height=").concat(height, ", top=").concat(top, ", left=").concat(left);
  var popup = window.open(url, 'Connect', windowFeatures);
  if (!openerAllowed) {
    popup.opener = null;
  }
  return popup;
};
function connectListing(listingId, v1ListingId) {
  return /*#__PURE__*/function () {
    var _connectListingAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var state, ID, oAuthWorkflowType, _state$userPrefs$loca, lang, _state$userProfile, _state$userProfile2, profile, _state$listing, needAnAccountClicked, isConnecting, connectButtonClickCorrelationID, options, response, json, errorsWithIds, popupWindow;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            state = getState();
            ID = (0, _has2.default)(state, "listing[".concat(listingId, "].data.core")) ? listingId : v1ListingId;
            oAuthWorkflowType = state.listing[ID].data.core.oAuthWorkflowType;
            _state$userPrefs$loca = state.userPrefs.localeData.lang, lang = _state$userPrefs$loca === void 0 ? 'en-us' : _state$userPrefs$loca, _state$userProfile = state.userProfile, _state$userProfile2 = _state$userProfile === void 0 ? {} : _state$userProfile, profile = _state$userProfile2.profile, _state$listing = state.listing, needAnAccountClicked = _state$listing.needAnAccountClicked, isConnecting = _state$listing.isConnecting;
            if (!isConnecting) {
              dispatch(connectionStatusChecking());
            }
            dispatch({
              type: CONNECT_LISTING
            });
            if (!(oAuthWorkflowType === 'AUTOCONFLOW' && !needAnAccountClicked)) {
              _context6.next = 10;
              break;
            }
            dispatch(connectWithLoyaltyNumberLegacy(ID));
            _context6.next = 27;
            break;
          case 10:
            connectButtonClickCorrelationID = uuid();
            _nuiLogger.default.info({
              'cte.category': 'client-connect-button-click',
              correlation_id: connectButtonClickCorrelationID,
              description: "Connect button clicked for listing with id: ".concat(listingId)
            });
            options = {
              method: 'PUT',
              headers: {
                'concur-correlationid': connectButtonClickCorrelationID
              }
            };
            options.credentials = 'include';
            _context6.prev = 14;
            _context6.next = 17;
            return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(profile), "/v3/listings/").concat(ID, "/connections").concat((0, _utils.buildQueryString)({
              lang: lang
            })), options);
          case 17:
            response = _context6.sent;
            _context6.next = 20;
            return response.json();
          case 20:
            json = _context6.sent;
            if (json.errors) {
              errorsWithIds = json.errors.map(function (error) {
                return _objectSpread(_objectSpread({}, error), {}, {
                  componentId: uuid()
                });
              });
              dispatch(setErrors(listingId, errorsWithIds));
            } else {
              dispatch(setErrors(listingId, []));
              popupWindow = openConnectionWindow({
                url: json.redirectUrl,
                width: 800,
                height: 650,
                openerAllowed: json.openerAllowed
              });
              dispatch(checkForConnection(listingId, v1ListingId, popupWindow));
            }
            _context6.next = 27;
            break;
          case 24:
            _context6.prev = 24;
            _context6.t0 = _context6["catch"](14);
            dispatch(setErrors(listingId, ['Failed to connect to listing. Please try again later.']));
          case 27:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[14, 24]]);
    }));
    function connectListingAsync(_x9, _x10) {
      return _connectListingAsync.apply(this, arguments);
    }
    return connectListingAsync;
  }();
}
var toggleModal = exports.toggleModal = function toggleModal(modalName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: TOGGLE_MODAL,
    modalName: modalName,
    options: options
  };
};
function disconnectListing(listingId, v1ListingId) {
  return /*#__PURE__*/function () {
    var _disconnectListingAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var state, _state$userPrefs$loca2, lang, _state$userProfile3, _state$userProfile4, profile, ID, confirmOrDeny, connectURL, listingType, success, endpoint, _success, disconnectButtonClickCorrelationID, options, disconnectEndpoint, isCustom, response, json, errorsWithIds, _response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            state = getState();
            _state$userPrefs$loca2 = state.userPrefs.localeData.lang, lang = _state$userPrefs$loca2 === void 0 ? 'en-us' : _state$userPrefs$loca2;
            _state$userProfile3 = state.userProfile, _state$userProfile4 = _state$userProfile3 === void 0 ? {} : _state$userProfile3, profile = _state$userProfile4.profile;
            ID = getListingID(listingId, v1ListingId, state);
            confirmOrDeny = function confirmOrDeny(wasSuccess, listingType) {
              if (wasSuccess) {
                dispatch(disconnectFromListing(ID));
                dispatch((0, _listingsModule.updateConnectedStatus)(ID, false));
                dispatch(toggleModal(CONFIRMATION_MODAL, {
                  disconnectSuccess: true,
                  listingType: listingType
                }));
              } else {
                dispatch(toggleModal(CONFIRMATION_MODAL, {
                  disconnectSuccess: false,
                  listingType: listingType
                }));
              }
            };
            connectURL = state.listing[ID].data.localized.connectURL || '';
            listingType = state.listing[ID].data.core.listingType;
            if (!(connectURL.indexOf('/signup_tripit.asp') !== -1)) {
              _context7.next = 14;
              break;
            }
            _context7.next = 10;
            return disconnectTripIt(state.userPrefs.csrf_token);
          case 10:
            success = _context7.sent;
            confirmOrDeny(success, listingType);
            _context7.next = 48;
            break;
          case 14:
            if (!(listingType === 'ACONCT')) {
              _context7.next = 22;
              break;
            }
            endpoint = "/ui/appcenter/ChangeAutoConnectPreference?enroll=false&_=".concat(new Date().getTime());
            _context7.next = 18;
            return makeXMLHttpRequest(endpoint);
          case 18:
            _success = _context7.sent;
            confirmOrDeny(_success, listingType);
            _context7.next = 48;
            break;
          case 22:
            disconnectButtonClickCorrelationID = uuid();
            _nuiLogger.default.info({
              'cte.category': 'client-disconnect-button-click',
              correlation_id: disconnectButtonClickCorrelationID,
              description: "Disconnect button clicked for listing with id: ".concat(listingId)
            });
            options = {
              method: 'DELETE',
              headers: {
                'concur-correlationid': disconnectButtonClickCorrelationID
              }
            };
            options.credentials = 'include';
            disconnectEndpoint = listingType === 'AUTOCONFLOW' ? "".concat((0, _utils.getAPIEndpoint)(profile), "/connections/").concat(ID) : "".concat((0, _utils.getAPIEndpoint)(profile), "/v3/listings/").concat(ID, "/connections");
            _context7.prev = 27;
            isCustom = state.listing[ID].data.hasCustomDisconnectUrl;
            if (!isCustom) {
              _context7.next = 39;
              break;
            }
            _context7.next = 32;
            return (0, _isomorphicFetch.default)("".concat(disconnectEndpoint).concat((0, _utils.buildQueryString)({
              lang: lang
            })), options);
          case 32:
            response = _context7.sent;
            _context7.next = 35;
            return response.json();
          case 35:
            json = _context7.sent;
            if (json.errors) {
              errorsWithIds = json.errors.map(function (error) {
                return _objectSpread(_objectSpread({}, error), {}, {
                  componentId: uuid()
                });
              });
              dispatch(setErrors(listingId, errorsWithIds));
            } else {
              dispatch(setErrors(listingId, []));
              openConnectionWindow({
                url: json.disconnectUrl,
                width: 800,
                height: 650,
                openerAllowed: false
              });
            }
            _context7.next = 43;
            break;
          case 39:
            _context7.next = 41;
            return (0, _isomorphicFetch.default)(disconnectEndpoint, options);
          case 41:
            _response = _context7.sent;
            confirmOrDeny(_response.ok);
          case 43:
            _context7.next = 48;
            break;
          case 45:
            _context7.prev = 45;
            _context7.t0 = _context7["catch"](27);
            console.error(_context7.t0);
          case 48:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[27, 45]]);
    }));
    function disconnectListingAsync(_x11, _x12) {
      return _disconnectListingAsync.apply(this, arguments);
    }
    return disconnectListingAsync;
  }();
}
function updateLoyaltyNum(listingId, loyaltyNum) {
  return {
    type: UPDATE_LOYALTY_NUM,
    listingId: listingId,
    loyaltyNum: loyaltyNum
  };
}
function inquireListing() {
  return {
    type: INQUIRE_LISTING
  };
}

// Reducer

var initialState = exports.initialState = {
  isEnrollModalOpen: false,
  isDisconnectModalOpen: false,
  isConfirmationModalOpen: false,
  isUnenrollModalOpen: false,
  isConnecting: false,
  errors: {},
  needAnAccountClicked: false,
  modalOptions: {},
  modalNames: {
    enroll: ENROLL_MODAL,
    unenroll: UNENROLL_MODAL,
    disconnect: DISCONNECT_MODAL,
    confirmation: CONFIRMATION_MODAL
  }
};

// Needed in src/app/configureStore.js to set initial state on the server side

function listing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LISTING_FETCHING:
      return (0, _merge11.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_FETCHING
      }));
    case SET_ERRORS:
      {
        var statePrime = _objectSpread({}, state);
        statePrime.errors[action.listingId] = action.errors;
        return statePrime;
      }
    case LISTING_FETCH_FAILED:
      return (0, _merge11.default)({}, state, _defineProperty({}, action.ID, {
        readyState: LISTING_FETCH_FAILED,
        error: action.error
      }));
    case LISTING_FETCHED:
      return (0, _merge11.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.listingId, {
        readyState: LISTING_FETCHED,
        data: _objectSpread(_objectSpread({}, action.result), {}, {
          loyaltyNumber: ''
        })
      }));
    case LISTING_NOT_FOUND:
      return (0, _merge11.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_NOT_FOUND,
        data: action.result
      }));
    case CONNECT_LISTING:
      return state;
    case DISCONNECT_LISTING:
      return (0, _merge11.default)({}, state, _defineProperty({}, action.listingId, {
        data: {
          core: {
            isUserConnected: false
          }
        }
      }));
    case CONNECTION_STATUS_CHECKING:
      return (0, _merge11.default)({}, state, {
        isConnecting: true
      });
    case SET_IS_CONNECTING_TO_FALSE:
      return (0, _merge11.default)({}, state, {
        isConnecting: false
      });
    case CONNECTION_STATUS_CHECKED_SUCCESS:
      return (0, _merge11.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.ID, {
        data: {
          core: {
            isUserConnected: true
          }
        }
      }));
    case UPDATE_CONNECTION_PENDING:
      return (0, _merge11.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.listingId, {
        data: {
          core: {
            isConnectionPending: true
          }
        }
      }));
    case REGIONS_FETCHED:
      return (0, _merge11.default)({}, state, {
        localizedRegions: action.json
      });
    case COUNTRIES_FETCHED:
      return (0, _merge11.default)({}, state, {
        localizedCountries: action.json
      });
    case TOGGLE_MODAL:
      {
        var modalKey;
        switch (action.modalName) {
          case ENROLL_MODAL:
            modalKey = 'isEnrollModalOpen';
            break;
          case UNENROLL_MODAL:
            modalKey = 'isUnenrollModalOpen';
            break;
          case DISCONNECT_MODAL:
            modalKey = 'isDisconnectModalOpen';
            break;
          case CONFIRMATION_MODAL:
            modalKey = 'isConfirmationModalOpen';
            break;
          default:
            console.error('toggle requires a modal constant found in listingModule.js');
            break;
        }
        return (0, _merge11.default)({}, state, _defineProperty(_defineProperty({}, modalKey, !state[modalKey]), "modalOptions", _objectSpread(_objectSpread({}, state.modalOptions), action.options)));
      }
    case UPDATE_LOYALTY_NUM:
      return (0, _merge11.default)({}, state, _defineProperty({}, action.listingId, {
        data: {
          loyaltyNumber: action.loyaltyNum
        }
      }));
    case TOGGLE_NEED_AN_ACCOUNT_CLICKED:
      return (0, _merge11.default)({}, state, {
        needAnAccountClicked: action.wasClicked
      });
    default:
      return state;
  }
}